import { useCallback } from 'react';
import { SuggestionDataItem } from 'react-mentions';

const isLogicalWord = (word: string): boolean => {
  const logicalPattern = /[aeiouáéíóúüñ]/i;
  return logicalPattern.test(word) && word.length <= 25;
};

const splitLongWord = (word: string, maxLength: number): string[] => {
  const chunks = [];
  for (let i = 0; i < word.length; i += maxLength) {
    chunks.push(word.slice(i, i + maxLength));
  }
  return chunks;
};

const processText = (text: string, maxLength: number): string => {
  const words = text.split(' ');
  const result: string[] = [];

  words.forEach((word) => {
    if (!isLogicalWord(word) && word.length > maxLength) {
      result.push(...splitLongWord(word, maxLength));
    } else {
      result.push(word);
    }
  });

  return result.join(' ');
};

export const useCommentParagraph = () => {
  const Comment = useCallback(({ comment }: { comment: string }) => {
    if (comment !== '') {
      const regex = /@\[.+?\]\(.+?\)/gm;
      const displayRegex = /@\[.+?\]/g;
      const idRegex = /\(.+?\)/g;
      const matches = comment.match(regex);
      const arr: SuggestionDataItem[] = [];

      matches?.forEach((m: string) => {
        const matchResult = m.match(idRegex);
        const matchDisplay = m.match(displayRegex);
        if (matchResult && matchDisplay) {
          const id = matchResult[0].replace('(', '').replace(')', '');
          const display = matchDisplay[0].replace('@[', '').replace(']', '');
          arr.push({ id, display });
        }
      });

      const newComment = comment.split(regex);
      let output = '';

      for (let i = 0; i < newComment.length; i++) {
        const c = newComment[i];
        if (i === newComment.length - 1) {
          output += c;
        } else {
          output += c + `<strong>${arr[i].display}</strong>`;
        }
      }

      const processedText = processText(output, 38);
      const html = processedText.replace(/\n/g, '<br />');

      return (
        <div>
          <p
            dangerouslySetInnerHTML={{ __html: html }}
            className="d-inline comment-paragraph-text"
          />
        </div>
      );
    }
  }, []);

  return {
    Comment,
  };
};
